import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import breakpoint from "styled-components-breakpoint"
import { Column } from "@ui-kit/helpers"

import Award from "../award"

const itemTypes = {
  taxonomy_term__awards: Award,
}

export default ({
  relationships: {
    queue: { qid },
  },
}) => {
  const {
    queues: { nodes: queues },
  } = useStaticQuery(query)

  const queue = queues.find((q) => q.relationships.queue.qid === qid)

  const {
    relationships: {
      queue: {
        relationships: { items: queueItems },
      },
    },
  } = queue

  return queueItems.length > 0 ? (
    <Style>
      <Column>
        <ul>
          {queueItems.map((item, i) => {
            const Component = itemTypes[item.type]
            return (
              <li key={i}>
                <Component {...item} />
              </li>
            )
          })}
        </ul>
      </Column>
    </Style>
  ) : null
}

const query = graphql`
  query {
    queues: allParagraphTaxonomyGrid {
      nodes {
        relationships {
          queue: field_queue {
            qid: drupal_internal__name
            relationships {
              items {
                type: __typename
                ... on taxonomy_term__awards {
                  award: name
                  awardedBy: field_awarded_by
                  awardYear: field_year
                  relationships {
                    icon: field_theme {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

const Style = styled.section.attrs((props) => ({
  className: "promotion promotion--taxonomy-grid",
}))`
  ul {
    list-style: none;
    margin: 0 auto;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    max-width: 1000px;

    ${breakpoint("sm")`
            flex-direction: row;
        `}

    > li {
      flex: 1;
      margin-bottom: 0;
      margin-top: 1em;

      ${breakpoint("sm")`
                margin-top: 0;
            `}
    }
  }
`
